// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Acs__TenantController from "./acs/tenant_controller"
application.register("acs--tenant", Acs__TenantController)

import Acs__TenantFlatpickrController from "./acs/tenant_flatpickr_controller"
application.register("acs--tenant-flatpickr", Acs__TenantFlatpickrController)

import Acs__VisitorController from "./acs/visitor_controller"
application.register("acs--visitor", Acs__VisitorController)

import Cctv__ArchiveController from "./cctv/archive_controller"
application.register("cctv--archive", Cctv__ArchiveController)

import Cctv__ArchiveTimeLineController from "./cctv/archive_time_line_controller"
application.register("cctv--archive-time-line", Cctv__ArchiveTimeLineController)

import Cctv__CameraController from "./cctv/camera_controller"
application.register("cctv--camera", Cctv__CameraController)

import Cctv__ColumnResponsiveController from "./cctv/column_responsive_controller"
application.register("cctv--column-responsive", Cctv__ColumnResponsiveController)

import Cctv__ExportController from "./cctv/export_controller"
application.register("cctv--export", Cctv__ExportController)

import Cctv__ExportSpinnerController from "./cctv/export_spinner_controller"
application.register("cctv--export-spinner", Cctv__ExportSpinnerController)

import Cctv__NanoCosmosCameraController from "./cctv/nano_cosmos_camera_controller"
application.register("cctv--nano-cosmos-camera", Cctv__NanoCosmosCameraController)

import Cctv__NotificationController from "./cctv/notification_controller"
application.register("cctv--notification", Cctv__NotificationController)

import Cctv__PopupController from "./cctv/popup_controller"
application.register("cctv--popup", Cctv__PopupController)

import Cctv__RadiantMpCameraController from "./cctv/radiant_mp_camera_controller"
application.register("cctv--radiant-mp-camera", Cctv__RadiantMpCameraController)

import Cctv__RangeSliderController from "./cctv/range_slider_controller"
application.register("cctv--range-slider", Cctv__RangeSliderController)

import Cctv__ReplayController from "./cctv/replay_controller"
application.register("cctv--replay", Cctv__ReplayController)

import Cctv__SelectController from "./cctv/select_controller"
application.register("cctv--select", Cctv__SelectController)

import Cctv__VclPluginCameraController from "./cctv/vcl_plugin_camera_controller"
application.register("cctv--vcl-plugin-camera", Cctv__VclPluginCameraController)

import Cctv__VisibilityController from "./cctv/visibility_controller"
application.register("cctv--visibility", Cctv__VisibilityController)

import ClearFieldController from "./clear_field_controller"
application.register("clear-field", ClearFieldController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import FilterExportController from "./filter_export_controller"
application.register("filter-export", FilterExportController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import GeckoSnap__FileUploadController from "./gecko_snap/file_upload_controller"
application.register("gecko-snap--file-upload", GeckoSnap__FileUploadController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import Monitoring__GraphController from "./monitoring/graph_controller"
application.register("monitoring--graph", Monitoring__GraphController)

import Monitoring__HostController from "./monitoring/host_controller"
application.register("monitoring--host", Monitoring__HostController)

import Monitoring__HostImportController from "./monitoring/host_import_controller"
application.register("monitoring--host-import", Monitoring__HostImportController)

import Monitoring__Map__MapsController from "./monitoring/map/maps_controller"
application.register("monitoring--map--maps", Monitoring__Map__MapsController)

import Monitoring__Map__MarkerController from "./monitoring/map/marker_controller"
application.register("monitoring--map--marker", Monitoring__Map__MarkerController)

import Monitoring__TimeLineController from "./monitoring/time_line_controller"
application.register("monitoring--time-line", Monitoring__TimeLineController)

import Monitoring__TimePeriodController from "./monitoring/time_period_controller"
application.register("monitoring--time-period", Monitoring__TimePeriodController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PartnerTasks__EquipmentCollectedController from "./partner_tasks/equipment_collected_controller"
application.register("partner-tasks--equipment-collected", PartnerTasks__EquipmentCollectedController)

import RemoteController from "./remote_controller"
application.register("remote", RemoteController)

import SelectAllController from "./select_all_controller"
application.register("select-all", SelectAllController)

import SignInController from "./sign_in_controller"
application.register("sign-in", SignInController)

import SwitchViewController from "./switch_view_controller"
application.register("switch-view", SwitchViewController)

import TomSelect__FilterController from "./tom_select/filter_controller"
application.register("tom-select--filter", TomSelect__FilterController)

import TomSelect__SearchController from "./tom_select/search_controller"
application.register("tom-select--search", TomSelect__SearchController)

import TomSelect__SelectController from "./tom_select/select_controller"
application.register("tom-select--select", TomSelect__SelectController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import Vmware__OrganizationInputController from "./vmware/organization_input_controller"
application.register("vmware--organization-input", Vmware__OrganizationInputController)
